import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { AboutComponent } from './about.component';
import { AboutLayoutComponent } from './about.layout';


export const routes: Routes = [
  {
    path: '',
    component: AboutLayoutComponent,
    children: [
       {
        path: '',
        component: AboutComponent
       }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AboutRoutingModule {
}
